import { render, staticRenderFns } from "./reviews.vue?vue&type=template&id=3b0af3f0&"
import script from "./reviews.vue?vue&type=script&lang=ts&"
export * from "./reviews.vue?vue&type=script&lang=ts&"
import style0 from "./reviews.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports